import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { QRCodeSVG } from 'qrcode.react'

const APP_STORE_URL = 'https://apps.apple.com/ca/app/callizy/id6755805657'
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.callizy.softphone'
const QR_URL = 'https://callizy.ca/app'
export const STORAGE_KEY = 'callizy_mobile_browser_ack'
const MOBILE_BREAKPOINT_PX = 768

export function MobileBrowserSplash() {
  const { t } = useTranslation()
  const [shouldShow, setShouldShow] = useState(false)

  useEffect(() => {
    // Si l'utilisateur a déjà ack, le viewport desktop est déjà appliqué
    // dans main.tsx avant le mount React → rien à faire ici.
    const acked = localStorage.getItem(STORAGE_KEY) === '1'
    if (acked) return
    if (window.innerWidth < MOBILE_BREAKPOINT_PX) {
      setShouldShow(true)
    }
  }, [])

  const handleContinue = () => {
    localStorage.setItem(STORAGE_KEY, '1')
    // Reload pour que main.tsx applique le viewport 1280 AVANT React, et que
    // Tailwind résolve les media queries `md:` en branche desktop dès le 1er render.
    window.location.reload()
  }

  if (!shouldShow) return null

  return (
    <div
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center px-6 py-10 overflow-y-auto"
      style={{ backgroundColor: '#0A192F', color: 'white' }}
    >
      <div className="w-full max-w-sm flex flex-col items-center">
        <img
          src="https://sdk.callizy.ca/assets/favicon_callizy.png"
          alt="Callizy"
          className="h-12 w-12 mb-6"
        />

        <h1 className="text-2xl font-bold tracking-tight text-center mb-3">
          {t('mobileSplash.title')}
        </h1>
        <p className="text-sm text-center mb-8" style={{ color: '#94A3B8' }}>
          {t('mobileSplash.subtitle')}
        </p>

        <div className="p-3 bg-white rounded-2xl mb-3">
          <QRCodeSVG
            value={QR_URL}
            size={140}
            bgColor="#ffffff"
            fgColor="#0A192F"
            level="M"
            imageSettings={{
              src: 'https://sdk.callizy.ca/assets/favicon_callizy.png',
              height: 28,
              width: 28,
              excavate: true,
            }}
          />
        </div>
        <span className="text-xs font-medium mb-8" style={{ color: '#94A3B8' }}>
          {t('mobileSplash.scanToDownload')}
        </span>

        <div className="flex flex-col w-full gap-3 mb-8">
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 px-5 py-3 rounded-xl transition-colors hover:bg-white/10"
            style={{ border: '1px solid rgba(255,255,255,0.2)' }}
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.1 2.48-1.34.03-1.77-.79-3.29-.79-1.53 0-1.99.77-3.26.82-1.31.05-2.31-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.24-1.99 1.1-3.15-1.02.04-2.25.68-2.97 1.53-.64.73-1.21 1.93-1.05 3.06 1.13.09 2.26-.67 2.92-1.44Z" />
            </svg>
            <div className="text-left">
              <div className="text-[10px] uppercase leading-none opacity-60">
                {t('mobileSplash.downloadOnAppStore')}
              </div>
              <div className="text-sm font-bold">{t('mobileSplash.appStore')}</div>
            </div>
          </a>

          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 px-5 py-3 rounded-xl transition-colors hover:bg-white/10"
            style={{ border: '1px solid rgba(255,255,255,0.2)' }}
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.61 3,21.09 3,20.5M16.81,15.12L18.66,14.05C20.44,13.03 20.44,10.97 18.66,9.95L16.81,8.88L14.4,11.31L16.81,15.12M13.69,12.69L16.1,15.12L16.1,15.12L4.54,21.81C4.31,21.94 4.06,22 3.82,22C3.67,22 3.52,21.97 3.38,21.91L13.69,12.69M14.4,10.69L16.81,8.88L16.81,8.88L4.54,2.19C4.31,2.06 4.06,2 3.82,2C3.67,2 3.52,2.03 3.38,2.09L13.69,11.31L14.4,10.69Z" />
            </svg>
            <div className="text-left">
              <div className="text-[10px] uppercase leading-none opacity-60">
                {t('mobileSplash.availableOn')}
              </div>
              <div className="text-sm font-bold">{t('mobileSplash.googlePlay')}</div>
            </div>
          </a>
        </div>

        <button
          type="button"
          onClick={handleContinue}
          className="text-sm font-medium underline-offset-4 hover:underline transition-colors"
          style={{ color: '#94A3B8' }}
        >
          {t('mobileSplash.continueInBrowser')}
        </button>
      </div>
    </div>
  )
}
